exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-6f295178]{font-size:12px}.errorStyle[data-v-6f295178]{font-weight:bolder;color:red}", ""]);

// exports
